export enum ProfileTypes {
  FB = 'fb',
  GOOGLE = 'google',
  APPLE = 'apple',
  TELEGRAM = 'telegram',
}
